<h3 color="primary" class="popup-header">Forgot Password</h3>
<mat-dialog-content class="mat-typography">
  <custom-popup-message></custom-popup-message>
  <div fxLayout="column">
    <mat-form-field fxFill>
      <input matInput placeholder="Username" maxlength="50" [(ngModel)]="dataModel.username" required />
    </mat-form-field>
    <mat-form-field fxFill>
      <input matInput type="email" placeholder="Email Address" [(ngModel)]="dataModel.emailId" required />
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="primary" (click)="saveClick()">
    <i class="fas fa-check"></i> Save
  </button>
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Cancel
  </button>
</mat-dialog-actions>